export default __webpack_public_path__ + "static/media/line-4-left.d5d990f6.svg";